const ACCESS_CODE_INVALID_MODAL = 'ACCESS_CODE_INVALID_MODAL';


export const ModalTypes = {
    ACCESS_CODE_INVALID_MODAL
};